<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de visita domiciliar">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/atencao-basica/relatorio-visita-domiciliar/List'

export default {
    components: { List },
}
</script>
